import { createFileRoute } from '@tanstack/react-router';
import { HStack, VStack } from '@/components/Layout';
import NavigationCard, { type NavigationSectionGroup } from '@/components/Navigation/NavigationCard';
import { featureFlags } from '@/lib/env';
import { defaultNS, useTranslation } from '@/lib/i18n';

// モック: 証明書の様式設定（ID4/ID8）。不要になればこの import と下の分岐を削除できる
import { CertificateFormatSection } from '../../_egov-mock/certificate-issuance/-components/CertificateFormatSection';
import { SubmissionSiteSection } from '../../_egov-mock/worker-roster/-components/SubmissionSiteSection';
import { ApplicantContactsSection } from './-components/ApplicantContactsSection';
export const Route = createFileRoute('/_staff/labor-core/_packages/settings/')({
  component: SettingsPage
});
function SettingsPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.laborCore.settings'
  });
  const isCertificateFormatMockEnabled = featureFlags.check('LABOR_PLUS_MOCK');
  const navigationSections: NavigationSectionGroup[] = [{
    titleLabel: '',
    to: '/labor-core/settings',
    sections: [{
      label: t('applicantContacts.title'),
      hash: 'applicant-contacts'
    }, ...(isCertificateFormatMockEnabled ? [{
      label: '証明書の様式',
      hash: 'certificate-formats'
    }, {
      label: '名簿の提出先',
      hash: 'submission-sites'
    }] : [])]
  }];
  return <HStack className="p-8 gap-8">
      <nav className="sticky top-8 h-fit w-60">
        <NavigationCard sections={navigationSections} />
      </nav>
      <VStack className="w-full gap-12">
        <div id="applicant-contacts">
          <ApplicantContactsSection />
        </div>
        {isCertificateFormatMockEnabled && <>
            <div id="certificate-formats">
              <CertificateFormatSection />
            </div>
            <div id="submission-sites">
              <SubmissionSiteSection />
            </div>
          </>}
      </VStack>
    </HStack>;
}